import { render, staticRenderFns } from "./NotPass.vue?vue&type=template&id=efdd15e4&"
import script from "./NotPass.vue?vue&type=script&lang=js&"
export * from "./NotPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports